export default "__VITE_ASSET__rd6_WxwB__"